import Icon from "@mui/material/Icon";
import MDButton from "components/MDButton";

// Bouton de suppression standardisé : icône cancel rouge + texte "Supprimer"
function BoutonSupprimer({ onClick, label = "Supprimer", size = "small" }) {
  return (
    <MDButton size={size} color="error" variant="outlined" onClick={onClick}>
      <Icon>cancel</Icon>&nbsp;{label}
    </MDButton>
  );
}

export default BoutonSupprimer;
